import { cx } from "@/utils/cx";

type ExpiryStatus = "on_going" | "expiring" | "completed";

type Props = {
  status: ExpiryStatus;
  endTime: string | null;
};

const LABELS: Record<ExpiryStatus, string> = {
  on_going: "On Going",
  expiring: "Expiring",
  completed: "Completed",
};

const COLORS: Record<ExpiryStatus, string> = {
  on_going: "text-success-600",
  expiring: "text-warning-600",
  completed: "text-tertiary",
};

const dateFormatter = new Intl.DateTimeFormat("en-GB", { day: "2-digit", month: "2-digit", year: "2-digit" });

export const ExpiryStatusCell = ({ status, endTime }: Props) => {
  return (
    <div className="flex flex-col">
      <span className={cx("text-xs font-medium whitespace-nowrap", COLORS[status])}>{LABELS[status]}</span>
      {endTime && (
        <span className="text-xs text-tertiary whitespace-nowrap">{dateFormatter.format(new Date(endTime))}</span>
      )}
    </div>
  );
};
